import React from 'react'
import { isEmpty } from 'lodash'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import {
  Grid,
  TextField,
  Box,
  IconButton,
  Button,
  Switch,
  FormControlLabel,
} from '@material-ui/core'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'

import { Card, Select as SelectComponent } from 'components'

import constants from 'constants/index'

import useStyles from './styles'

const FantasyDpoForm = ({ disabled = false }) => {
  const classes = useStyles()
  const { control, errors } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'fantasyDpos',
  })

  const addNewDpo = () => {
    append(constants.fantasyDpo.DEFAULT_DPO_VALUES)
  }

  const removeDpo = (index) => {
    if (fields.length > 1) {
      remove(index)
    }
  }

  return (
    <Box>
      <Box className={classes.buttonContainer}>
        <Button
          startIcon={<AddIcon />}
          onClick={addNewDpo}
          disabled={disabled}
          variant="contained"
          color="primary"
        >
          Adicionar DPO
        </Button>
      </Box>
      <Box>
        {fields.map((field, index) => (
          <Card
            key={field.id}
            className={classes.dpoCard}
            title={`DPO Fantasia ${index + 1}`}
            actionButton={
              fields.length > 1 && (
                <IconButton
                  onClick={() => removeDpo(index)}
                  disabled={disabled}
                  size="small"
                  color="secondary"
                  className={classes.deleteButton}
                >
                  <DeleteIcon />
                </IconButton>
              )
            }
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name={`fantasyDpos.${index}.id`}
                  control={control}
                  as={<input type="hidden" />}
                  mode="onBlur"
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name={`fantasyDpos.${index}.name`}
                  control={control}
                  as={
                    <TextField
                      label="Nome completo"
                      fullWidth
                      variant="outlined"
                      error={!isEmpty(errors.fantasyDpos?.[index]?.name)}
                      helperText={errors.fantasyDpos?.[index]?.name?.message}
                      disabled={disabled}
                    />
                  }
                  mode="onBlur"
                />
              </Grid>

              <Grid item xs={12}>
                <Controller
                  name={`fantasyDpos.${index}.email`}
                  control={control}
                  as={
                    <TextField
                      label="E-mail"
                      type="email"
                      fullWidth
                      variant="outlined"
                      error={!isEmpty(errors.fantasyDpos?.[index]?.email)}
                      helperText={errors.fantasyDpos?.[index]?.email?.message}
                      disabled={disabled}
                    />
                  }
                  mode="onBlur"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Controller
                  name={`fantasyDpos.${index}.kind`}
                  control={control}
                  as={
                    <SelectComponent
                      label="Função"
                      items={constants.fantasyDpo.DPO_TYPE_OPTIONS}
                      error={!isEmpty(errors.fantasyDpos?.[index]?.kind)}
                      helperText={errors.fantasyDpos?.[index]?.kind?.message}
                      disabled={disabled}
                    />
                  }
                  mode="onChange"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Controller
                      as={<Switch color="primary" />}
                      name={`fantasyDpos.${index}.active`}
                      control={control}
                      onChange={([event]) => event.target.checked}
                    />
                  }
                  label="Ativo (visível no portal de privacidade)"
                />
              </Grid>
            </Grid>
          </Card>
        ))}
      </Box>
    </Box>
  )
}

FantasyDpoForm.defaultProps = {
  disabled: false,
}

export default FantasyDpoForm
